const locale = {
  placeholderCountry: 'Please Select Country',
  placeholderInput: 'Please Input {label}',
  notAllowedEmpty: '{label} are not allowed to be empty',
  incorrectFormat: 'Incorrect format of {label}'
};

export default locale;
